import { render, staticRenderFns } from "./Entregada.vue?vue&type=template&id=a1230a04&"
import script from "./Entregada.vue?vue&type=script&lang=js&"
export * from "./Entregada.vue?vue&type=script&lang=js&"
import style0 from "./Entregada.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports